import { render, staticRenderFns } from "./F10Statements.vue?vue&type=template&id=8fa31ff4"
import script from "./F10Statements.vue?vue&type=script&lang=js"
export * from "./F10Statements.vue?vue&type=script&lang=js"
import style0 from "./F10Statements.vue?vue&type=style&index=0&id=8fa31ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports